module.exports = __webpack_public_path__ + "static/img/1.fd73ba45.png";